import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import decode from 'jwt-decode'
import findIndex from 'lodash/findIndex'
// import $loading from 'vue-load-progress'
import modulos from '@app/admin/modulos/store'
import contasBancarias from '@app/admin/contasBancarias/store'
import servicos from '@app/admin/servicos/store'
import contas from '@app/admin/contas/store'
import funcionalidades from '@app/admin/funcionalidades/store'
import contasBancariasUsuarios from '@app/admin/contasBancariasUsuarios/store'
import comprarFichas from '@app/admin/comprarFichas/store'
import venderFichas from '@app/admin/venderFichas/store'
import tiposUsuarios from '@app/admin/tiposUsuarios/store'
import perfis from '@app/admin/perfis/store'
import usuarios from '@app/admin/usuarios/store'
import transacoesCompraVenda from '@app/admin/transacoesCompraVenda/store'
import astroPay from '@app/admin/astroPay/store'
import chats from '@app/admin/chats/store'
import indicacoes from '@app/admin/indicacoes/store'
import cadastro from '@app/vp/curriculo/cadastro/store'
import meusCurriculos from '@app/vp/curriculo/meusCurriculos/store'
import minhasAnotacoes from '@app/vp/curriculo/minhasAnotacoes/store'
import geral from '@/store/state.js'
import auth from '@app/auth/store'
import notaFiscal from '@app/admin/notaFiscal/store'
import localforage from 'localforage'
import comprarCursos from '@app/admin/comprarCursos/store'

Vue.use(Vuex)

const modules = {
  modulos,
  contasBancarias,
  servicos,
  contas,
  indicacoes,
  comprarFichas,
  venderFichas,
  funcionalidades,
  tiposUsuarios,
  contasBancariasUsuarios,
  perfis,
  usuarios,
  transacoesCompraVenda,
  astroPay,
  chats,
  cadastro,
  meusCurriculos,
  minhasAnotacoes,
  auth,
  notaFiscal,
  comprarCursos
}

const isUnique = async (context, obj) => {
  const { object, value, feature, verb, id } = obj
  const list = context.rootState[feature].list
  let arr = JSON.parse(JSON.stringify(list))
  if (verb === 'put') {
    const index = findIndex(arr, { id })
    if (index > -1) {
      arr.splice(index, 1)
    }
  }
  return findIndex(arr, {[object]: value}) > -1 ? Boolean(false) : true
}

const isUniqueRegister = async (context, obj) => {
  const { object, value, feature } = obj

  const list = await context.rootState[feature].fetchOne('/usuario/verificarSeUsuarioExiste/' + value)
  // console.log(list)

  let arr = JSON.parse(JSON.stringify(list))
  return findIndex(arr, {[object]: value}) > -1 ? Boolean(false) : true
}

export default new Vuex.Store({
  modules,
  strict: process.env.NODE_ENV !== 'production',
  state: {
    menu: [],
    it: false,
    activeIndex: null,
    leftOpen: true,
    isSearching: false,
    controlSearching: false,
    token: null,
    ipClient: null,
    route: null,
    logo: null,
    menuSide: {},
    versaoSistema: '1.0.0',
    optionsToast: {
      closeButton: true,
      debug: false,
      newestOnTop: true,
      progressBar: true,
      positionClass: 'toast-top-center pt-3',
      preventDuplicates: true,
      onclick: null,
      showDuration: '300',
      hideDuration: '1000',
      timeOut: '5000',
      extendedTimeOut: '5000',
      showEasing: 'swing',
      hideEasing: 'linear',
      showMethod: 'fadeIn',
      hideMethod: 'fadeOut'
    },
    ...geral
  },
  actions: {
    setSearching ({ commit }, obj) {
      commit('SET_SEARCHING', obj)
    },
    setToken ({ commit }, obj) {
      commit('SET_TOKEN', obj)
    },
    setIpClient ({ commit }, obj) {
      commit('SET_IP_CLIENT', obj)
    },
    setIt ({ commit }, obj) {
      commit('SET_IT', obj)
    },
    leftMenu ({ commit }, option) {
      commit('LEFT_MENU', option)
    },
    navigation ({ commit }, route) {
      commit('NAVIGATION', route)
    },
    removeToken ({ commit }) {
      commit('SET_MENU', [])
      commit('REMOVE_TOKEN')
    },
    toast ({ commit }, obj) {
      commit('TOAST', obj)
    },
    setMenu ({commit}, val) {
      localforage.setItem('menu', val)
      commit('SET_MENU', val)
    },
    setActiveIndex ({commit}, val) {
      commit('SET_ACTIVE_INDEX', val)
    },
    isUnique,
    isUniqueRegister
  },
  mutations: {
    SET_SEARCHING (state, obj) {
      // console.log(state.isSearching)
      state.isSearching = obj.isSearching
    },
    SET_TOKEN (state, obj) {
      state.token = obj.token
    },
    SET_IP_CLIENT (state, obj) {
      state.ipClient = obj
    },
    SET_IT (state, obj) {
      state.it = obj
    },
    LEFT_MENU (state) {
      state.leftOpen = !state.leftOpen
      if (!state.leftOpen) {
        document.getElementsByClassName('left-side')[0].childNodes[0].childNodes[0].classList.remove('showSpan')
        document.getElementsByClassName('left-side')[0].childNodes[0].childNodes[0].classList.add('collapse')

        document.getElementsByClassName('left-side')[0].childNodes[0].childNodes[0].classList.remove('fixo-open')
        document.getElementsByClassName('left-side')[0].childNodes[0].childNodes[0].classList.add('fixo-close')

        document.getElementsByClassName('left-side')[0].childNodes[0].childNodes[0].classList.remove('rolavel-open')
        document.getElementsByClassName('left-side')[0].childNodes[0].childNodes[0].classList.add('rolavel-close')

        document.getElementsByClassName('right-aside')[0].classList.remove('toogle-menu-right-open')
        document.getElementsByClassName('right-aside')[0].classList.add('toogle-menu-right-close')
        document.getElementsByClassName('sidebar-toggle')[0].classList.remove('toogle-menu-header-open')
        document.getElementsByClassName('sidebar-toggle')[0].classList.add('toogle-menu-header-close')
      } else {
        document.getElementsByClassName('left-side')[0].childNodes[0].childNodes[0].classList.remove('collapse')
        document.getElementsByClassName('left-side')[0].childNodes[0].childNodes[0].classList.add('showSpan')

        document.getElementsByClassName('left-side')[0].childNodes[0].childNodes[0].classList.add('fixo-open')
        document.getElementsByClassName('left-side')[0].childNodes[0].childNodes[0].classList.remove('fixo-close')

        document.getElementsByClassName('left-side')[0].childNodes[0].childNodes[0].classList.add('rolavel-open')
        document.getElementsByClassName('left-side')[0].childNodes[0].childNodes[0].classList.remove('rolavel-close')

        document.getElementsByClassName('right-aside')[0].classList.add('toogle-menu-right-open')
        document.getElementsByClassName('right-aside')[0].classList.remove('toogle-menu-right-close')
        document.getElementsByClassName('sidebar-toggle')[0].classList.add('toogle-menu-header-open')
        document.getElementsByClassName('sidebar-toggle')[0].classList.remove('toogle-menu-header-close')
      }
    },
    NAVIGATION (state, route) {
      state.route = route
      // console.log(route)

      router.push({ name: state.route })
    },
    REMOVE_TOKEN (state) {
      state.menu = []
      state.token = null
      state.it = false
    },
    TOAST (state, obj) {
      const { verb, message, title, options, toast } = obj
      if (options !== null) {
        state.optionsToast = options
      }
      toast[verb](message, title, state.optionsToast)
    },
    SET_MENU (state, val) {
      state.menu = val
    },
    SET_ACTIVE_INDEX (state, val) {
      state.activeIndex = val
    }
  },
  getters: {
    role (state) {
      const { token } = state
      if (token !== null) {
        const decoded = decode(token)
        return decoded.role
      }
      return null
    },
    usuarioLogado (state) {
      const { token } = state
      if (token !== null) {
        return decode(token)
      }
      return null
    },
    isAdministrator (state) {
      const { token } = state
      if (token !== null) {
        return decode(token)
      }
      return null
    },
    versao (state) {
      return state.versaoSistema
    },
    getMenu (state) {
      return state.menu
    },
    getNavigation (state) {
      return state.route
    },
    getIt (state) {
      return state.it
    },
    getIpClient (state) {
      return state.ipClient
    },
    getActiveIndex (state) {
      return state.activeIndex
    },
    estados (state) {
      return state.estados
    },
    getLeftOpen (state) {
      return state.leftOpen
    },
    sexos (state) {
      return state.sexos
    },
    paises (state) {
      return state.paises
    },
    cidades (state) {
      return state.cidades
    },
    bancos (state) {
      const { bancos } = state
      if (bancos !== null) {
        bancos.forEach((value) => {
          value.banco = value.value + ' - ' + value.label
        })
        return bancos
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js